<template>
  <div class="comReport">
    <div class="dataList">
        <no-message v-if="!contractList.length"></no-message>
        <div v-for="(item,index) in contractList" class="item" @click="details(item)" :key="index">
          <div class="item_top">
           <img class="top_i1" :src="require(`../../assets/images/icon_contract_${common.theme}.png`)" alt="">
           <span class="top_t">{{item.contNo}}</span>
           <img class="top_i2" src="../../assets/images/icon_indicator_next.png" alt="">
          </div>
          <div class="item_bottom">
            <div class="bottom_line">
              <span class="line_title">租客名称</span>
              <span class="line_text">{{item.companyName}}</span>
            </div>
            <div class="bottom_line">
              <span class="line_title">项目名称</span>
              <span class="line_text">{{item.mallName}}</span>
            </div>
            <!-- <div class="bottom_line">
              <span class="line_title">房源</span>
              <span class="line_text">{{item.storeName}}</span>
            </div> -->
            <div class="bottom_line">
              <div class="bottom_line">
                <span class="line_title">开始日期</span>
                <span class="line_text">{{item.contBeginDate|toDate}}</span>
              </div>
              <div class="bottom_line">
                <span class="line_title">结束日期</span>
                <span class="line_text">{{item.contEndDate|toDate}}</span>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import NoMessage from '../../components/nomessage';
import util from '../../utils/util';
import {getContractList} from '../../utils/api';
import { mapState } from 'vuex';
export default {
  name: 'comReport',
  props: {
  },
  components: {
    NoMessage
  },
  filters: {
    toDate: function (value) {
      return util.formatTime(new Date(value), 4);
    },
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data () {
    return {
      contractList:[
        // {
        //     companyId:1,
        //     companyName:"a",
        //     contBeginDate:1532102400000,
        //     contEndDate:1606752000000,
        //     contNo:"HT-021-00002382",
        //     contractName:"AT317-318",
        //     mallId:1,
        //     mallName:"\U5b89\U4ead\U4e07\U521b\U574a",
        //     storeName:"317,318",
        //     storeNo: "60,61",
        // },
        // {
        //     companyId:1,
        //     companyName:"2",
        //     contBeginDate:1530374400000,
        //     contEndDate:1577721600000,
        //     contNo:"HT-021-00002613",
        //     contractName:"\U63d0\U6210\U6d4b\U8bd51",
        //     mallId:1,
        //     mallName:"\U5b89\U4ead\U4e07\U521b\U574a",
        //     storeName:"436",
        //     storeNo: "60,61",
        // }
      ]
    };
  },
  created () {
    this.getContractList();
  },
  methods: {
    details(item){
      this.$router.push(`/comReportingDetails?id=${item.localId}&contNo=${item.contNo}`);
    },
    getContractList(){
      getContractList({
        userId: this.common.userId,
        permissionType:'REPORT'
      }, {
        userId: this.common.userId,
        openId: this.common.openId
      }).then(res => {
        console.log("合同列表");
        console.log(res);
        this.contractList = res.body.contractList
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.comReport{
  height: 100vh;
  background:rgba(237, 237, 237, 1);
  .dataList{
    height: 100vh;
  }
  .item{
    width: 710px;
    min-height: 316px;
    background:rgba(255,255,255,1);
    border-radius:8px;
    margin:20px 20px 0;
    display: flex;
    flex-direction: column;
    .item_top{
      height:88px;
      background:rgba(248,248,248,1);
      border-radius:8px 8px 0px 0px;
      display: flex;
      align-items: center;
      padding: 22px 20px 22px 30px;
      box-sizing: border-box;
      .top_i1{
        height: 32px;
        width: 32px;
        background: #f3f4f6;
        margin-right: 22px;
      }
      .top_t{
        flex: 1;
        height:44px;
        font-size:32px;
        font-family:PingFangSC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:44px;
      }
      .top_i2{
        height: 32px;
        width: 32px;
      }
    }
    .item_bottom{
      flex: 1;
      padding: 28px 28px 0;
      box-sizing: border-box;
      display: flex;flex-direction: column;
      .bottom_line{
        height: 28px;
        margin-bottom: 20px;
        display: flex;
        flex: 1;
        .line_title{
          display: inline-block;
          font-size:24px;
          width:124px;
          color:rgba(153,153,153,1);
          line-height: 28px;
        }
        .line_text{
          flex:1;
          height:28px;
          font-size:24px;
          color:rgba(51,51,51,1);
          line-height:28px;
          .textOver(100%);
        }
      }
    }
  }
}

</style>
